import * as yup from "yup";

const ANALYSIS_TYPE_OPTIONS = [
  { label: "Binary Model", value: "binary_model" },
];

const NEW_ANALYSIS_INITIAL_VALUES = {
  analysisName: "",
  analysisType: ANALYSIS_TYPE_OPTIONS[0],
  analysisTarget: 'Target in {"1"}',
};

const NEW_ANALYSIS_VALIDATION_SCHEMA = yup.object({
  analysisName: yup.string().trim().required("Analysis name is required"),
  analysisType: yup.object().required("Analysis type is required"),
  analysisTarget: yup.string().trim().required("Analysis target is required"),
});

const JOB_STATUS_TYPE = {
  running: "running",
  finished: "finished",
  failed: "failed",
  orphaned: "orphaned",
};

Object.freeze(JOB_STATUS_TYPE);

export {
  NEW_ANALYSIS_INITIAL_VALUES,
  NEW_ANALYSIS_VALIDATION_SCHEMA,
  ANALYSIS_TYPE_OPTIONS,
  JOB_STATUS_TYPE,
};
